"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useYouwellDispatch = exports.useYouwellSelector = exports.history = exports.reducers = void 0;
var react_localize_redux_1 = require("react-localize-redux");
var history_1 = require("history");
var react_redux_1 = require("react-redux");
var AuthStore = __importStar(require("./AuthStore"));
var ProgramStore = __importStar(require("./ProgramStore"));
var UserStore = __importStar(require("./UserStore"));
var PageSettingStore = __importStar(require("./PageSettingStore"));
var PublicStore = __importStar(require("./PublicStore"));
var PreviewStore = __importStar(require("./PreviewStore"));
var SleepDataStore_1 = __importDefault(require("./SleepDataStore"));
var ActivityDataStore_1 = __importDefault(require("./ActivityDataStore"));
var OutsideStore_1 = __importDefault(require("./OutsideStore"));
var reduxUtils_1 = require("../../youwell-common/reduxUtils");
var RequestStatusStore_1 = __importDefault(require("../../youwell-common/service/RequestStatusStore"));
var ExternalUserStore_1 = __importDefault(require("./ExternalUserStore"));
var PatientConsentStore_1 = __importDefault(require("./PatientConsentStore"));
exports.reducers = {
    localize: react_localize_redux_1.localizeReducer,
    auth: AuthStore.reducer,
    programStore: ProgramStore.reducer,
    user: UserStore.reducer,
    pageSettings: PageSettingStore.reducer,
    publicStore: PublicStore.reducer,
    previewStore: PreviewStore.reducer,
    activityDataStore: ActivityDataStore_1.default,
    sleepDataStore: SleepDataStore_1.default,
    requestStatusStore: RequestStatusStore_1.default,
    outsideStore: OutsideStore_1.default,
    externalUserStore: ExternalUserStore_1.default,
    patientConsentStore: PatientConsentStore_1.default,
};
var baseUrl = ((_a = document.getElementById('react-app')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-base-url')) || undefined;
// Create browser history to use in the Redux store
exports.history = (0, history_1.createBrowserHistory)({ basename: baseUrl });
// Get the application-wide store instance, prepopulating with state from the server where available.
var store = (0, reduxUtils_1.configureStore)(exports.reducers, exports.history);
// export type RootStore = ReturnType<typeof store.getState>;
exports.useYouwellSelector = react_redux_1.useSelector;
var useYouwellDispatch = function () { return (0, react_redux_1.useDispatch)(); };
exports.useYouwellDispatch = useYouwellDispatch;
exports.default = store;
